export type UserInfo = Partial<{
  user_id: number;
  user_name: string;
  alias: string;
  head_img_url: string;
  is_member: boolean;
  member_status: number;
  member_save_amount: number;
  member_expired_timestamp: number;
  member_free_offer_expired_timestamp: string;
  is_ldu: boolean;
  ua_channel_id: string;
  user_feature: number;
  isLogin: boolean;
  favoriteIds: number[];
  addresses: Address[];
  couponNumber: number | string;
  discountCopy?: any;
  commonBarCopy?: any;
  rewardsInfo?: any;
  //客户端业务字段
  show_favorite_tip?: boolean;
  favoriteIdsLoaded?: boolean;
  userBoughtData?: any[];
}>;

export interface AccountInfo {
  member_expire_timestamp: number;
  is_ldu: boolean;
  points_current: number;
  language: string;
  show_welcome_style: boolean;
  ua_channel_id: string;
  user_feature: number;
  post_privilege: boolean;
  user_type: string;
  filter: {
    zipcode: string;
    ethnic_group: string;
    support_alcohol: string;
  };
  user_id: number;
  member: boolean;
  alias: string;
  phone_number: string;
  head_img_url: string;
}

export type NewUserCoupon = {
  invite_friends_amount: number | string;
  normal_amount: number | string;
  register_phone_amount: number | string;
  normal_amount_count?: number | string;
  normal_amount_tip?: number;
  support_referrer_experiment?: boolean;
  bind_phone_amount?: number;
};

export type Discount = {
  amount: number;
  free_delivery: number;
  order_amount_limit: number;
  percentage: number;
};

export interface ICouponListItem {
  valid?: boolean; // 是否展示黄金权益效果
  content?: {
    success?: boolean;
    msg?: string;
    expiration_time_text?: string;
    expiration_time?: number;
  };
  button?: {
    success?: boolean;
    text: string;
    link: string;
    type: string;
    theme_type: string;
  };
  id?: number;
  amount: number;
  code: string;
  group_id: number;
  start_timestamp?: any;
  percentage: number;
  expiration_timestamp: number;
  title: string;
  sub_title: string;
  icon_text: string;
  type: string;
  invalid_message: string;
  used_timestamp?: string;
  rule_title?: string[];
  rule_info?: any;
  discount?: Discount[] | [];
  coupon_plan_id?: number;
  relate_sku?: number;
  vendor_id?: number;
  tree_v2_free?: boolean;
  redeem_code?: string;
}

export interface ICouponLists {
  coupon_list: ICouponListItem[] | [];
}
export interface FAQInfo {
  supplier_topics: FaqInfoListItem[];
  user_topics: FaqInfoListItem[];
}

export interface FaqInfoListItem {
  title: string;
  language: string;
  help_id: string | null;
  url: string;
}

export enum ConsentSmsSource {
  Verify = 'phone_verification',
  Checkout = 'checkout_address'
}

export enum LoginMethod {
  GOOGLE = 'google',
  FACEBOOK = 'facebook',
  EMAIL = 'email',
  PHONE = 'phone'
}
